/**
 * "A sign-out did not reach the server" flag (D2-SEC-014, #4081).
 *
 * Set when the logout POST fails, so the refresh cookie may still be live; the
 * next session restore retries the server sign-out (`completePendingLogout`)
 * and refuses to restore while it keeps failing. A fresh login clears it.
 */
export const LOGOUT_PENDING_STORAGE_KEY = "lwp_logout_pending";

export function isLogoutPending(): boolean {
  try {
    return Boolean(localStorage.getItem(LOGOUT_PENDING_STORAGE_KEY));
  } catch {
    return false;
  }
}

export function setLogoutPending(pending: boolean): void {
  try {
    if (pending) localStorage.setItem(LOGOUT_PENDING_STORAGE_KEY, "1");
    else localStorage.removeItem(LOGOUT_PENDING_STORAGE_KEY);
  } catch {
    // Storage unavailable: nothing more we can do.
  }
}
